import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Title } from '@lib/components/v2/Title';
import { localizedString } from '@languages';
import { useLogo } from '@js/hooks/useLogo';
import { getAltTextLogo } from '@lib/Utils';
import classes from './NoMobileDeviceWrapper.style.module.scss';

export const NoMobileDeviceWrapper = ({ title = '', children }) => {
  const finalLogo = useLogo();
  const titleText = title.length > 0 ? title : localizedString('mobileIDVerification.title');

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <img
          alt={getAltTextLogo()}
          className={classNames(classes.logo, 'b-logo')}
          src={finalLogo}
        />
        <div className={classes.block}>
          <Title className={classes.title} title={titleText} />
          <div className={classes.content}>{children}</div>
        </div>
      </div>
    </div>
  );
};

NoMobileDeviceWrapper.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node
};
